module.exports = __webpack_public_path__ + "img/application_button_1.67073980.png";